import React from 'react';

interface FormTemplateProps {
  template: string | undefined;
  setEdital: React.Dispatch<React.SetStateAction<string>>;
  edital: string;
  setRazaoSocial: React.Dispatch<React.SetStateAction<string>>;
  razaoSocial: string;
  cnpj: string;
  setCnpj: React.Dispatch<React.SetStateAction<string>>;
  setResponsavel: React.Dispatch<React.SetStateAction<string>>;
  responsavel: string;
  setCargo: React.Dispatch<React.SetStateAction<string>>;
  cargo: string;
  setRg: React.Dispatch<React.SetStateAction<string>>;
  rg: string;
  expedidor: string;
  setExpedidor: React.Dispatch<React.SetStateAction<string>>;
  cpf: string;
  setCpf: React.Dispatch<React.SetStateAction<string>>;
  cidade: string;
  setCidade: React.Dispatch<React.SetStateAction<string>>;
  setNomeCredenciado: React.Dispatch<React.SetStateAction<string>>;
  nomeCredenciado: string;
  setRgCredenciado: React.Dispatch<React.SetStateAction<string>>;
  rgCredenciado: string;
  setExpedidorCredenciado: React.Dispatch<React.SetStateAction<string>>;
  expedidorCredenciado: string;
  setCpfCredenciado: React.Dispatch<React.SetStateAction<string>>;
  cpfCredenciado: string;
}

const FormTemplate = (props: FormTemplateProps) => {
  const {
    template,
    setEdital,
    edital,
    setRazaoSocial,
    razaoSocial,
    cnpj,
    setCnpj,
    setResponsavel,
    responsavel,
    setCargo,
    cargo,
    setRg,
    rg,
    expedidor,
    setExpedidor,
    cpf,
    setCpf,
    cidade,
    setCidade,
    setNomeCredenciado,
    nomeCredenciado,
    setRgCredenciado,
    rgCredenciado,
    setExpedidorCredenciado,
    expedidorCredenciado,
    setCpfCredenciado,
    cpfCredenciado,
  } = props;

  if (template === undefined) {
    return null;
  }

  return (
    <div>
      <div id="steps">
        <div className="row">
          <div className="col-12">
            <div className="form-group">
              <input
                className="form-control form-template"
                value={edital}
                name="edital"
                placeholder="Edital"
                onChange={(event) => setEdital(event.target.value)}
              />
            </div>
          </div>
        </div>
        <div className="row">
          <div className="col-6">
            <div className="form-group">
              <input
                className="form-control form-template"
                name="razao_social"
                value={razaoSocial}
                placeholder="Razão Social"
                onChange={(event) => setRazaoSocial(event.target.value)}
              />
            </div>
          </div>
          <div className="col-6">
            <div className="form-group">
              <input
                className="form-control form-template"
                name="cnpj"
                placeholder="CNPJ"
                value={cnpj}
                onChange={(event) => setCnpj(event.target.value)}
              />
            </div>
          </div>
        </div>
        <div className="row">
          <div className="col-6">
            <div className="form-group">
              <input
                className="form-control form-template"
                name="responsavel"
                placeholder="Responsável"
                value={responsavel}
                onChange={(event) => setResponsavel(event.target.value)}
              />
            </div>
          </div>
          <div className="col-6">
            <div className="form-group">
              <input
                className="form-control form-template"
                name="cargo"
                placeholder="Cargo"
                value={cargo}
                onChange={(event) => setCargo(event.target.value)}
              />
            </div>
          </div>
        </div>
        <div className="row">
          <div className="col-5">
            <div className="form-group">
              <input
                className="form-control form-template"
                name="numero_rg"
                placeholder="RG"
                value={rg}
                onChange={(event) => setRg(event.target.value)}
              />
            </div>
          </div>
          <div className="col-2 p-0">
            <div className="form-group">
              <input
                className="form-control form-template"
                name="orgao_expedidor"
                placeholder="Órgão Expedidor"
                value={expedidor}
                onChange={(event) => setExpedidor(event.target.value)}
              />
            </div>
          </div>
          <div className="col-5">
            <div className="form-group">
              <input
                className="form-control form-template"
                name="numero_cpf"
                placeholder="CPF"
                value={cpf}
                onChange={(event) => setCpf(event.target.value)}
              />
            </div>
          </div>
          {template !== 'carta_credenciamento' && (
            <div className="col-5">
              <div className="form-group">
                <input
                  className="form-control form-template"
                  name="cidade"
                  placeholder="Cidade"
                  value={cidade}
                  onChange={(event) => setCidade(event.target.value)}
                />
              </div>
            </div>
          )}
        </div>
        {template === 'carta_credenciamento' && (
          <div>
            <div className="row">
              <div className="col-6">
                <div className="form-group">
                  <input
                    className="form-control form-template"
                    name="credenciado"
                    placeholder="Nome do Credenciado"
                    value={nomeCredenciado}
                    onChange={(event) => setNomeCredenciado(event.target.value)}
                  />
                </div>
              </div>
              <div className="col-6">
                <div className="form-group">
                  <input
                    className="form-control form-template"
                    name="cidade"
                    placeholder="Cidade"
                    value={cidade}
                    onChange={(event) => setCidade(event.target.value)}
                  />
                </div>
              </div>
            </div>
            <div className="row">
              <div className="col-5">
                <div className="form-group">
                  <input
                    className="form-control form-template"
                    name="numero_rg_credenciado"
                    placeholder="RG (Credenciado)"
                    value={rgCredenciado}
                    onChange={(event) => setRgCredenciado(event.target.value)}
                  />
                </div>
              </div>
              <div className="col-2 p-0">
                <div className="form-group">
                  <input
                    className="form-control form-template"
                    name="orgao_expedidor_credenciado"
                    placeholder="Órgão Expedidor (Credenciado)"
                    value={expedidorCredenciado}
                    onChange={(event) => setExpedidorCredenciado(event.target.value)}
                  />
                </div>
              </div>
              <div className="col-5">
                <div className="form-group">
                  <input
                    className="form-control form-template"
                    name="numero_cpf_credenciado"
                    placeholder="CPF (Credenciado)"
                    value={cpfCredenciado}
                    onChange={(event) => setCpfCredenciado(event.target.value)}
                  />
                </div>
              </div>
            </div>
          </div>
        )}
      </div>
    </div>
  );
};

export default FormTemplate;
